import React, { useEffect, useState, useContext } from "react";
import LandingHeader from "../../components/LandingHeader/Header";
import LandingFooter from "../../components/footer/LandingFooter";
import { contentContext } from "../../context/contentContext";
import { useLocation, useNavigate } from "react-router-dom";
const Dubbing = () => {
    const [config, setConfig] = useState({});
    const navigate = useNavigate();
    const { menus, setContentSearchFlag, inactiveFlag, setInactiveFlag, contentSearchFlag, clientData, setClientData, setRoute } = useContext(contentContext);
    let img = window.app.img;
    useEffect(() => {
        if (window.site) {
            setConfig(window.site);

        }

    }, [window.site]);



    if (config.common && config.common.imagesCDN) {
        img = config.common.imagesCDN;
    }

    const handleAll = () => {
        navigate("/faq");
        window.scrollTo(0, 0);
    }
    return (
        <>
            <LandingHeader />

            <section className="production-hero-section ">
                <div className="production-hero-bg">
                    <img src={`${img}orasi/client/resources/orasiv1/images/f6da0913b6ca7aa036c7825ebecec69dc44ec127.png`} alt="Background"
                        className="production-bg-img" />
                </div>

                <div className="container-fluid production-hero-container">
                    <div className="production-hero-content d-flex flex-column align-items-center text-center justify-content-center">
                        <div className="production-hero-text-wrapper">
                            <p className="production-hero-subtitle" data-aos="fade-up" data-aos-duration="1000">Live Dubbing & Subtitling</p>
                            <h1 className="production-hero-title" data-aos="fade-up" data-aos-duration="1400">One story, infinite audiences.</h1>
                            <p className="production-hero-description" data-aos="fade-up" data-aos-duration="1800">
                                From scripted shows to live sports, Orasi’s AI-powered dubbing and subtitling service breaks language barriers — with 50+ languages available in real time.
                            </p>
                        </div>

                        <button className="custom-btn-primary " data-aos="fade-up" data-aos-duration="2200" onClick={() => { navigate("/contactus"); window.scrollTo(0, 0); }} >
                            See it in Action
                            <span className="material-icons">north_east</span>
                        </button>
                    </div>
                </div>
            </section>

            <section className="challenge-solution-section ">
                <div className="container-fluid challenge-solution-container">
                    <div className="row g-4">
                        <div className="col-lg-6">
                            <div className="challenge-solution-card" data-aos="fade-up" data-aos-duration="1000">
                                <div className="card-header-icon">
                                    <span className="material-symbols-outlined">target</span>
                                    <h3>The Challenge</h3>
                                </div>
                                <p>Great content often stops at borders. Traditional dubbing is slow, expensive, and can’t handle live events.</p>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="challenge-solution-card" data-aos="fade-up" data-aos-duration="1400">
                                <div className="card-header-icon">
                                    <span className="material-symbols-outlined">star</span>
                                    <h3>The Solution</h3>
                                </div>
                                <p>We combine cloud-native pipelines, expressive AI voices, advanced voice separation, and real-time captioning to deliver multilingual streams instantly — keeping the emotion, sync, and energy of the original broadcast.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="production-features-section ">
                <div className="container-fluid production-features-container">
                    <div className="features-header">
                        <h2 data-aos="fade-up" data-aos-duration="1000">Made for live moments</h2>
                    </div>

                    <div className="features-grid">
                        <div className="production-feature-card" data-aos="fade-up" data-aos-duration="1000">
                            <div className="feature-image">
                                <img src={`${img}orasi/client/resources/orasiv1/images/dubbing-img-1.png`} alt="Real-Time Budgets" className="img-fluid" />
                            </div>
                            <div className="feature-content">
                                <h4>50+ Languages</h4>
                                <p>Expand reach across continents.</p>
                            </div>
                        </div>

                        <div className="production-feature-card" data-aos="fade-up" data-aos-duration="1400">
                            <div className="feature-image">
                                <img src={`${img}orasi/client/resources/orasiv1/images/dubbing-img-2.png`} alt="AI Assistance" className="img-fluid" />
                            </div>
                            <div className="feature-content">
                                <h4>Instant Multilingual Streams</h4>
                                <p>Add new languages within minutes.</p>
                            </div>
                        </div>

                        <div className="production-feature-card" data-aos="fade-up" data-aos-duration="1800">
                            <div className="feature-image">
                                <img src={`${img}orasi/client/resources/orasiv1/images/dubbing-img-3.png`} alt="Tool Integrations" className="img-fluid" />
                            </div>
                            <div className="feature-content">
                                <h4>Expressive AI Voices</h4>
                                <p>Each speaker receives a natural, emotive, and unique voice.</p>
                            </div>
                        </div>

                        <div className="production-feature-card" data-aos="fade-up" data-aos-duration="2200">
                            <div className="feature-image">
                                <img src={`${img}orasi/client/resources/orasiv1/images/dubbing-img-4.png`} alt="Storyboard in Seconds" className="img-fluid" />
                            </div>
                            <div className="feature-content">
                                <h4>Advanced Voice Separation</h4>
                                <p>Isolates multiple speakers while preserving background ambience like music and crowd reactions.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="target-audience-section ">
                <div className="container-fluid target-audience-container">
                    <div className="target-audience-card" data-aos="fade-up" data-aos-duration="1000">
                        <div className="row g-0">
                            <div className="col-lg-6">
                                <div className="target-section">
                                    <h3>Who is this for?</h3>
                                    <div className="target-list">
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">task_alt</span>
                                            <p>Sports Broadcasters – Localize live commentary instantly.</p>
                                        </div>
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">task_alt</span>
                                            <p>News Channels – Deliver breaking stories in multiple languages with AI voice and captions.</p>
                                        </div>
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">task_alt</span>
                                            <p>Broadcasters & OTT Platforms – Expand global reach in minutes.</p>
                                        </div>
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">task_alt</span>
                                            <p>Corporate & Government – Make events inclusive and multilingual.</p>
                                        </div>
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">task_alt</span>
                                            <p>Education & Worship – Connect international communities in real time.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="target-section">
                                    <h3>By the number</h3>
                                    <div className="target-list">
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">chevron_right</span>
                                            <p>One of the few global providers offering 24/7 live dubbing.</p>
                                        </div>
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">chevron_right</span>
                                            <p>50+ languages supported across scripted and live formats.</p>
                                        </div>
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">chevron_right</span>
                                            <p>Trusted for sports and news broadcasting.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="production-cta-section ">
                <div className="production-cta-bg"></div>

                <div className="container production-cta-container">
                    <div className="production-cta-content d-flex flex-column align-items-center text-center justify-content-center">
                        <p className="cta-subtitle" data-aos="fade-up" data-aos-duration="1000">Get Started</p>
                        <h2 className="cta-title" data-aos="fade-up" data-aos-duration="1400">
                            Let your story speak every language.
                        </h2>

                        <button className="custom-btn-primary" data-aos="fade-up" data-aos-duration="1800" onClick={() => { navigate("/contactus"); window.scrollTo(0, 0); }}>
                            Contact
                            <span className="material-icons">arrow_forward</span>
                        </button>
                    </div>
                </div>
            </section>


            <section className="faq-section">
                <div className="container-fluid faq-container">
                    <div className="faq-header">
                        <h2>Frequently Asked Questions</h2>
                    </div>

                    <div className="faq-list" id="faqAccordion">

                        {/* FAQ 1 */}
                        <div className="faq-item">
                            <div
                                className="faq-question"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq1"
                            >
                                <h4>How does subbing / dubbing process work?</h4>
                                <span className="material-icons faq-icon">expand_less</span>
                            </div>

                            <div
                                id="faq1"
                                className="collapse show"
                                data-bs-parent="#faqAccordion"
                            >
                                <div className="faq-answer">
                                    <p>
                                        For VOD content, submit the video file along with your target languages.
                                        Delivery typically occurs within a week depending on volume.
                                    </p>
                                    <p>
                                        For samples, send up to 5 minutes of footage to info@orasimedia.com.
                                    </p>
                                    <p>
                                        For live dubbing, send your SRT link and we will set up a 2-hour proof of concept (POC).
                                        We will return a live dubbed SRT with less than 5 seconds of delay.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* FAQ 2 */}
                        <div className="faq-item">
                            <div
                                className="faq-question collapsed"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq2"
                            >
                                <h4>What are the costs?</h4>
                                <span className="material-icons faq-icon">chevron_right</span>
                            </div>

                            <div id="faq2" className="collapse" data-bs-parent="#faqAccordion">
                                <div className="faq-answer">
                                    <p>Approximate pricing:</p>
                                    <ul>
                                        <p><strong>Subbing:</strong> $0.50–$3 per minute</p>
                                        <p>
                                            <strong>Dubbing (VOD):</strong> $2–$9 per minute
                                        </p>
                                        <p>
                                            <strong>Live dubbing:</strong> $0.25–$3 per minute
                                        </p>
                                    </ul>
                                    <p>Actual pricing varies based on language and volume.</p>
                                </div>
                            </div>
                        </div>

                        {/* FAQ 3 */}
                        <div className="faq-item">
                            <div
                                className="faq-question collapsed"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq3"
                            >
                                <h4>What is the accuracy?</h4>
                                <span className="material-icons faq-icon">chevron_right</span>
                            </div>

                            <div id="faq3" className="collapse" data-bs-parent="#faqAccordion">
                                <div className="faq-answer">
                                    <p>Accuracy varies by language pair</p>
                                    <ul>
                                        <p><strong>Common languages (Spanish, French, English, German, Arabic, Portuguese, etc):
                                        </strong> 95–98%</p>
                                        <p>
                                            <strong>Other languages:</strong> 85–98%
                                        </p>

                                    </ul>
                                </div>
                            </div>
                        </div>

                        {/* FAQ 4 */}
                        <div className="faq-item">
                            <div
                                className="faq-question collapsed"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq4"
                            >
                                <h4>What languages do we support?</h4>
                                <span className="material-icons faq-icon">chevron_right</span>
                            </div>
                            <div id="faq4" className="collapse" data-bs-parent="#faqAccordion">
                                <div className="faq-answer">
                                    <p>
                                        We support subbing and dubbing in 50+ languages.
                                        Contact us for specific details.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* FAQ 5 */}
                        <div className="faq-item">
                            <div
                                className="faq-question collapsed"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq5"
                            >
                                <h4>What is live dubbing / subbing?</h4>
                                <span className="material-icons faq-icon">chevron_right</span>
                            </div>
                            <div id="faq5" className="collapse" data-bs-parent="#faqAccordion">
                                <div className="faq-answer">
                                    <p>
                                        Any 24/7 channel or live event can be dubbed or subbed into another language with under 5 seconds of delay.


                                    </p>
                                </div>
                            </div>
                        </div>

                     
                        <div className="d-flex justify-content-end align-items-center">
                            <a className="anchor-txt" onClick={handleAll}>View All<span className="material-icons">chevron_right</span></a>
                        </div>
                    </div>
                </div>
            </section>
            <LandingFooter menus={menus} />
        </>
    );
};

export default Dubbing;
